import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=2d9d89ce&scoped=true"
var script = {}
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=2d9d89ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d89ce",
  null
  
)

export default component.exports